module.exports = __webpack_public_path__ + "static/1-ecf92a75df4cc40bd862a073e16b8ba9.jpg";